function Loader() {
  return (
    <>
      <h1>LOADING . . . </h1>
    </>
  );
}

export default Loader;
